import request from './request'

//虚拟病人发送消息
export function apiVpChat(data){
    return request({
        url:'/vp/chat',
        method:'post',
        data
    })
}
//获取历史对话
export function apiVpHistory(params){
    return request({
        url:'/vp/history',
        method:'get',
        params
    })
}

//【新增接口】获取病例基线信息
export function apiVpCaseBaseline(params){
    return request({
        url:'/vp/case',
        method:'get',
        params
    })
}
